// src/pages/AdminPublicaciones.jsx
import { useEffect, useMemo, useState } from "react";
import { auth, db } from "../firebase/firebase.js";
import {
  collection,
  getDocs,
  query,
  where,
  doc,
  updateDoc,
} from "firebase/firestore";
import { ESTATUS } from "../constants/status"; // si no lo tienes aquí, cambia strings directos

const REVIEW_STATES = [
  { key: "all", label: "Todas" },
  { key: "pending", label: "Pendientes" },
  { key: "approved", label: "Aprobadas" },
  { key: "rejected", label: "Rechazadas" },
];

export default function AdminPublicaciones() {
  const [me, setMe] = useState(null);

  const [motos, setMotos] = useState([]);
  const [selId, setSelId] = useState("");

  const [statusFilter, setStatusFilter] = useState("pending");
  const [search, setSearch] = useState("");

  const [form, setForm] = useState({
    id: "",
    nombre: "",
    codigoMoto: "",
    estatus: "pending",
    reviewStatus: "pending",
    reviewNote: "",
    ownerUid: "",
    ownerType: "seller",
    valor: "",
    valorRebajado: "",
    foto1: "",
    foto2: "",
    foto3: "",
    foto4: "",
    foto5: "",
    foto6: "",
    foto7: "",
    link_wooCommerce: "",
    docFacturaUrl: "",
    docTarjetaCirculacionUrl: "",
  });

  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    const u = auth.currentUser;
    setMe(u ? { uid: u.uid, email: u.email || "" } : null);
  }, []);

  // Carga motos ownerType=seller (publicaciones de seller)
  useEffect(() => {
    (async () => {
      setLoading(true);
      try {
        const qy = query(
          collection(db, "motos"),
          where("ownerType", "==", "seller")
        );
        const snap = await getDocs(qy);
        const list = snap.docs.map((d) => ({ id: d.id, ...d.data() }));

        // orden: reviewStatus, updatedAt desc
        list.sort((a, b) => {
          const sa = (a.reviewStatus || "pending").localeCompare(
            b.reviewStatus || "pending"
          );
          if (sa !== 0) return sa;
          const ta = a.updatedAt || "";
          const tb = b.updatedAt || "";
          return tb.localeCompare(ta);
        });

        setMotos(list);

        if (list.length > 0) {
          const f = list[0];
          setSelId(f.id);
          setForm({
            id: f.id,
            nombre: f.nombre || "",
            codigoMoto: f.codigoMoto || f.id,
            estatus: f.estatus || "pending",
            reviewStatus: f.reviewStatus || "pending",
            reviewNote: f.reviewNote || "",
            ownerUid: f.ownerUid || "",
            ownerType: f.ownerType || "seller",
            valor: f.valor ?? "",
            valorRebajado: f.valorRebajado ?? "",
            foto1: f.foto1 || "",
            foto2: f.foto2 || "",
            foto3: f.foto3 || "",
            foto4: f.foto4 || "",
            foto5: f.foto5 || "",
            foto6: f.foto6 || "",
            foto7: f.foto7 || "",
            link_wooCommerce: f.link_wooCommerce || "",
            docFacturaUrl: f.docFacturaUrl || "",
            docTarjetaCirculacionUrl: f.docTarjetaCirculacionUrl || "",
          });
        } else {
          setSelId("");
        }
      } catch (e) {
        console.error("[AdminPublicaciones] cargar:", e);
        alert("No se pudo cargar el listado de publicaciones de sellers.");
      } finally {
        setLoading(false);
      }
    })();
  }, []);

  // Cambiar selección
  useEffect(() => {
    if (!selId) return;
    const m = motos.find((x) => x.id === selId);
    if (!m) return;
    setForm({
      id: m.id,
      nombre: m.nombre || "",
      codigoMoto: m.codigoMoto || m.id,
      estatus: m.estatus || "pending",
      reviewStatus: m.reviewStatus || "pending",
      reviewNote: m.reviewNote || "",
      ownerUid: m.ownerUid || "",
      ownerType: m.ownerType || "seller",
      valor: m.valor ?? "",
      valorRebajado: m.valorRebajado ?? "",
      foto1: m.foto1 || "",
      foto2: m.foto2 || "",
      foto3: m.foto3 || "",
      foto4: m.foto4 || "",
      foto5: m.foto5 || "",
      foto6: m.foto6 || "",
      foto7: m.foto7 || "",
      link_wooCommerce: m.link_wooCommerce || "",
      docFacturaUrl: m.docFacturaUrl || "",
      docTarjetaCirculacionUrl: m.docTarjetaCirculacionUrl || "",
    });
  }, [selId, motos]);

  const filtered = useMemo(() => {
    let arr = motos;
    if (statusFilter !== "all") {
      arr = arr.filter((m) => (m.reviewStatus || "pending") === statusFilter);
    }
    const q = search.trim().toLowerCase();
    if (!q) return arr;
    return arr.filter((m) => {
      return (
        (m.nombre || "").toLowerCase().includes(q) ||
        (m.codigoMoto || m.id || "").toLowerCase().includes(q)
      );
    });
  }, [motos, statusFilter, search]);

  const aprobarPublicacion = async () => {
    if (!form.id) return;
    try {
      setSaving(true);

      // Al aprobar: reviewStatus=approved, reviewedBy/At, estatus=publicada, publishedOnce=true
      const ref = doc(db, "motos", form.id);
      await updateDoc(ref, {
        reviewStatus: "approved",
        reviewNote: form.reviewNote || "",
        reviewedBy: me?.uid || "admin",
        reviewedAt: new Date().toISOString(),
        estatus: ESTATUS ? ESTATUS.PUBLICADA : "publicada",
        publishedOnce: true,
        updatedAt: new Date().toISOString(),
      });

      alert("Publicación aprobada y publicada.");
      const list = motos.map((m) =>
        m.id === form.id
          ? {
              ...m,
              reviewStatus: "approved",
              reviewNote: form.reviewNote || "",
              reviewedBy: me?.uid || "admin",
              reviewedAt: new Date().toISOString(),
              estatus: ESTATUS ? ESTATUS.PUBLICADA : "publicada",
              publishedOnce: true,
            }
          : m
      );
      setMotos(list);
      setForm((v) => ({ ...v, reviewStatus: "approved", estatus: "publicada" }));
    } catch (e) {
      console.error("[AdminPublicaciones] aprobar:", e);
      alert(e.message || "No se pudo aprobar la publicación.");
    } finally {
      setSaving(false);
    }
  };

  const rechazarPublicacion = async () => {
    if (!form.id) return;
    if (!form.reviewNote.trim()) {
      alert("Indica un motivo de rechazo en la nota.");
      return;
    }
    try {
      setSaving(true);
      const ref = doc(db, "motos", form.id);
      await updateDoc(ref, {
        reviewStatus: "rejected",
        reviewNote: form.reviewNote.trim(),
        reviewedBy: me?.uid || "admin",
        reviewedAt: new Date().toISOString(),
        // estatus se mantiene como esté (normalmente 'pending')
        updatedAt: new Date().toISOString(),
      });

      alert("Publicación rechazada.");
      const list = motos.map((m) =>
        m.id === form.id
          ? {
              ...m,
              reviewStatus: "rejected",
              reviewNote: form.reviewNote.trim(),
              reviewedBy: me?.uid || "admin",
              reviewedAt: new Date().toISOString(),
            }
          : m
      );
      setMotos(list);
      setForm((v) => ({ ...v, reviewStatus: "rejected" }));
    } catch (e) {
      console.error("[AdminPublicaciones] rechazar:", e);
      alert(e.message || "No se pudo rechazar la publicación.");
    } finally {
      setSaving(false);
    }
  };

  if (loading) return <div className="p-6 text-gray-600">Cargando…</div>;

  return (
    <div className="min-h-screen bg-gray-100 text-gray-900">
      {/* Topbar */}
      <div className="px-6 py-4 border-b border-gray-200 bg-white flex justify-between items-center">
        <div className="font-semibold">Publicaciones de Sellers</div>
        <div className="text-sm text-gray-600">Admin · {me?.email || ""}</div>
      </div>

      <div className="p-6 grid grid-cols-1 lg:grid-cols-3 gap-6">
        {/* Lista */}
        <aside className="lg:col-span-1">
          <div className="rounded border border-gray-200 bg-white p-3 space-y-3">
            <div className="flex items-center gap-2">
              <select
                value={statusFilter}
                onChange={(e) => setStatusFilter(e.target.value)}
                className="px-2 py-1 rounded border border-gray-300 bg-gray-50"
              >
                {REVIEW_STATES.map((s) => (
                  <option key={s.key} value={s.key}>{s.label}</option>
                ))}
              </select>
              <input
                value={search}
                onChange={(e) => setSearch(e.target.value)}
                placeholder="Buscar…"
                className="flex-1 px-2 py-1 rounded border border-gray-300 bg-gray-50"
              />
            </div>

            <div className="space-y-1 max-h-[60vh] overflow-auto">
              {filtered.map((m) => {
                const thumb = m.foto1 || m.foto2 || m.foto3 || m.foto4 || m.foto5 || m.foto6 || m.foto7;
                return (
                  <button
                    key={m.id}
                    onClick={() => setSelId(m.id)}
                    className={`w-full text-left px-3 py-2 rounded border ${
                      selId === m.id ? "border-gray-900 bg-gray-50" : "border-gray-200 hover:bg-gray-50"
                    } flex items-center gap-2`}
                  >
                    <div className="w-12 h-10 rounded overflow-hidden border border-gray-200 bg-gray-100 flex-shrink-0">
                      {thumb ? (
                        <img src={thumb} alt="" className="w-full h-full object-cover" />
                      ) : (
                        <div className="w-full h-full text-[10px] flex items-center justify-center text-gray-400">
                          Sin foto
                        </div>
                      )}
                    </div>
                    <div className="flex-1 min-w-0">
                      <div className="font-medium truncate">{m.nombre || m.id}</div>
                      <div className="text-xs text-gray-500">
                        {m.codigoMoto || m.id} · {m.reviewStatus || "pending"}
                      </div>
                    </div>
                  </button>
                );
              })}
              {filtered.length === 0 && (
                <div className="text-sm text-gray-500 px-2 py-3">Sin resultados…</div>
              )}
            </div>
          </div>
        </aside>

        {/* Detalle */}
        <main className="lg:col-span-2">
          {selId ? (
            <div className="rounded border border-gray-200 bg-white p-4 space-y-4">
              {/* Encabezado */}
              <div className="grid grid-cols-1 md:grid-cols-3 gap-3">
                <div className="md:col-span-2">
                  <label className="text-sm text-gray-600">Nombre</label>
                  <input
                    value={form.nombre}
                    disabled
                    className="mt-1 w-full px-3 py-2 rounded border border-gray-300 bg-gray-100"
                  />
                </div>
                <div>
                  <label className="text-sm text-gray-600">Código</label>
                  <input
                    value={form.codigoMoto}
                    disabled
                    className="mt-1 w-full px-3 py-2 rounded border border-gray-300 bg-gray-100"
                  />
                </div>
              </div>

              {/* Media */}
              <div>
                <div className="text-sm text-gray-600 mb-2">Fotos</div>
                <div className="grid grid-cols-3 md:grid-cols-4 gap-2">
                  {[form.foto1, form.foto2, form.foto3, form.foto4, form.foto5, form.foto6, form.foto7]
                    .filter(Boolean)
                    .map((u, i) => (
                      <img key={i} src={u} alt="" className="w-full h-24 object-cover rounded border border-gray-200" />
                    ))}
                </div>
              </div>

              {/* Documentos */}
              <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
                <div>
                  <div className="text-sm text-gray-600">Doc. Factura (URL)</div>
                  {form.docFacturaUrl ? (
                    <a
                      href={form.docFacturaUrl}
                      target="_blank"
                      rel="noreferrer"
                      className="inline-block text-blue-600 underline text-sm mt-1 break-all"
                    >
                      {form.docFacturaUrl}
                    </a>
                  ) : (
                    <div className="text-sm text-gray-500 mt-1">No proporcionado</div>
                  )}
                </div>
                <div>
                  <div className="text-sm text-gray-600">Doc. Tarjeta de circulación (URL)</div>
                  {form.docTarjetaCirculacionUrl ? (
                    <a
                      href={form.docTarjetaCirculacionUrl}
                      target="_blank"
                      rel="noreferrer"
                      className="inline-block text-blue-600 underline text-sm mt-1 break-all"
                    >
                      {form.docTarjetaCirculacionUrl}
                    </a>
                  ) : (
                    <div className="text-sm text-gray-500 mt-1">No proporcionado</div>
                  )}
                </div>
              </div>

              {/* Estado y nota */}
              <div className="grid grid-cols-1 md:grid-cols-3 gap-3">
                <div>
                  <label className="text-sm text-gray-600">Estatus (actual)</label>
                  <input
                    value={form.estatus}
                    disabled
                    className="mt-1 w-full px-3 py-2 rounded border border-gray-300 bg-gray-100"
                  />
                </div>
                <div>
                  <label className="text-sm text-gray-600">Revisión (actual)</label>
                  <input
                    value={form.reviewStatus}
                    disabled
                    className="mt-1 w-full px-3 py-2 rounded border border-gray-300 bg-gray-100"
                  />
                </div>
                <div>
                  <label className="text-sm text-gray-600">Precio (MXN)</label>
                  <input
                    value={String(form.valor ?? "")}
                    disabled
                    className="mt-1 w-full px-3 py-2 rounded border border-gray-300 bg-gray-100"
                  />
                </div>
              </div>

              <div>
                <label className="text-sm text-gray-600">Nota / Motivo (si rechaza)</label>
                <textarea
                  rows={2}
                  value={form.reviewNote}
                  onChange={(e) => setForm((v) => ({ ...v, reviewNote: e.target.value }))}
                  className="mt-1 w-full px-3 py-2 rounded border border-gray-300 bg-gray-50"
                />
              </div>

              {/* Acciones */}
              <div className="flex items-center gap-3">
                <button
                  onClick={aprobarPublicacion}
                  disabled={saving || form.reviewStatus === "approved"}
                  className="px-4 py-2 rounded bg-emerald-600 text-white hover:bg-emerald-700 disabled:opacity-50"
                >
                  Aprobar publicación (publicar)
                </button>
                <button
                  onClick={rechazarPublicacion}
                  disabled={saving}
                  className="px-4 py-2 rounded bg-red-600 text-white hover:bg-red-700 disabled:opacity-50"
                >
                  Rechazar
                </button>
                <span className="text-sm text-gray-600 ml-auto">
                  Moto ID: <code>{form.id}</code>
                </span>
              </div>
            </div>
          ) : (
            <div className="text-gray-600">Selecciona una publicación…</div>
          )}
        </main>
      </div>
    </div>
  );
}